<template>
  <div class="common-page order-reassignment">
    <div class="tab-box">
      <custom-tab-box :tabData="tabData" @change="handleChangeTab" :selectTab="selectTab"></custom-tab-box>
    </div>
    <div class="search-form-box">
      <statement-account v-if="selectTab === 1"></statement-account>
      <unbilled-orders v-if="selectTab === 2"></unbilled-orders>
    </div>
  </div>
</template>

<script>
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import UnbilledOrders from "./unbilledOrders/index.vue";
import StatementAccount from "./statementAccount/index.vue";
export default {
  name: "ReconciliationBill",
  components: {
    UnbilledOrders,
    StatementAccount,
    CustomTabBox,
  },
  data() {
    return {
      selectTab: 1,
      tabData: [
        {
          label: 1,
          value: "对账单"
        },
        {
          label: 2,
          value: "未出账订单"
        },
      ],
    };
  },
  mounted() {},
  methods: {
    handleChangeTab(val) {
      this.selectTab = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.order-reassignment {
  display: flex;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
  .tab-box{
    flex-shrink: 0;
    padding: 15px;
    box-sizing: border-box;
  }
  .search-form-box{
    flex: 1;
    padding-top: 0;
    overflow: hidden;
  }
}
</style>
